export default __webpack_public_path__ + "static/media/bms.64739359.jpg";